/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/context/vhost.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
export class Vhost {
    /**
     * @param {?} vhost
     */
    constructor(vhost) {
        this.title = vhost.title;
        this.primaryPalette = vhost.primaryPalette;
        this.accentPalette = vhost.accentPalette;
    }
    /**
     * @return {?}
     */
    static fromBody() {
        /** @type {?} */
        const vhost = JSON.parse(document.body.dataset.vhost);
        return new Vhost(vhost);
    }
    /**
     * @return {?}
     */
    static empty() {
        return new Vhost({
            "title": "testing",
            "primaryPalette": "blue",
            "accentPalette": "grey",
        });
    }
}
if (false) {
    /** @type {?} */
    Vhost.prototype.title;
    /** @type {?} */
    Vhost.prototype.primaryPalette;
    /** @type {?} */
    Vhost.prototype.accentPalette;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmhvc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9jb250ZXh0L3Zob3N0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBRUEsTUFBTSxPQUFPLEtBQUs7Ozs7SUFDaEIsWUFBWSxLQUFLO1FBQ2YsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDO1FBQ3pCLElBQUksQ0FBQyxjQUFjLEdBQUcsS0FBSyxDQUFDLGNBQWMsQ0FBQztRQUMzQyxJQUFJLENBQUMsYUFBYSxHQUFHLEtBQUssQ0FBQyxhQUFhLENBQUM7SUFDM0MsQ0FBQzs7OztJQUVNLE1BQU0sQ0FBQyxRQUFROztjQUNkLEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQztRQUNyRCxPQUFPLElBQUksS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzFCLENBQUM7Ozs7SUFFTSxNQUFNLENBQUMsS0FBSztRQUNqQixPQUFPLElBQUksS0FBSyxDQUFDO1lBQ2YsT0FBTyxFQUFHLFNBQVM7WUFDbkIsZ0JBQWdCLEVBQUcsTUFBTTtZQUN6QixlQUFlLEVBQUcsTUFBTTtTQUN6QixDQUFDLENBQUM7SUFDTCxDQUFDO0NBS0Y7OztJQUhDLHNCQUF1Qjs7SUFDdkIsK0JBQWdDOztJQUNoQyw4QkFBK0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge0luamVjdGFibGV9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuXG5leHBvcnQgY2xhc3MgVmhvc3Qge1xuICBjb25zdHJ1Y3Rvcih2aG9zdCkge1xuICAgIHRoaXMudGl0bGUgPSB2aG9zdC50aXRsZTtcbiAgICB0aGlzLnByaW1hcnlQYWxldHRlID0gdmhvc3QucHJpbWFyeVBhbGV0dGU7XG4gICAgdGhpcy5hY2NlbnRQYWxldHRlID0gdmhvc3QuYWNjZW50UGFsZXR0ZTtcbiAgfVxuXG4gIHB1YmxpYyBzdGF0aWMgZnJvbUJvZHkoKTogVmhvc3Qge1xuICAgIGNvbnN0IHZob3N0ID0gSlNPTi5wYXJzZShkb2N1bWVudC5ib2R5LmRhdGFzZXQudmhvc3QpO1xuICAgIHJldHVybiBuZXcgVmhvc3Qodmhvc3QpO1xuICB9XG5cbiAgcHVibGljIHN0YXRpYyBlbXB0eSgpOiBWaG9zdCB7XG4gICAgcmV0dXJuIG5ldyBWaG9zdCh7XG4gICAgICBcInRpdGxlXCIgOiBcInRlc3RpbmdcIixcbiAgICAgIFwicHJpbWFyeVBhbGV0dGVcIiA6IFwiYmx1ZVwiLFxuICAgICAgXCJhY2NlbnRQYWxldHRlXCIgOiBcImdyZXlcIixcbiAgICB9KTtcbiAgfVxuXG4gIHJlYWRvbmx5IHRpdGxlOiBzdHJpbmc7XG4gIHJlYWRvbmx5IHByaW1hcnlQYWxldHRlOiBzdHJpbmc7XG4gIHJlYWRvbmx5IGFjY2VudFBhbGV0dGU6IHN0cmluZztcbn1cbiJdfQ==